import { render, staticRenderFns } from "./jkzc.vue?vue&type=template&id=7988cb04&scoped=true"
import script from "./jkzc.vue?vue&type=script&lang=js"
export * from "./jkzc.vue?vue&type=script&lang=js"
import style0 from "./jkzc.vue?vue&type=style&index=0&id=7988cb04&prod&scoped=true&lang=css"
import style1 from "./jkzc.vue?vue&type=style&index=1&id=7988cb04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7988cb04",
  null
  
)

export default component.exports